exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._31BJH{width:1024px;margin:auto;position:relative;border-radius:10px;overflow:hidden;max-width:100%}._1w3UC>span>a{cursor:unset;color:#0088bf!important}._1w3UC>span>a:hover{color:#0088bf;-webkit-filter:brightness(110%)}._3FMyZ{color:#4a4a4a}._3PgcV>*{text-align:left}@media only screen and (max-width:768px){._2TNHs{width:100%;max-width:100%}._3Nop6{display:none!important}}@media only screen and (min-width:768px){._2TNHs{width:100%;max-width:100%}._1dgJ_{display:none!important}}", ""]);

// exports
exports.locals = {
	"fixedContainer": "_31BJH",
	"childLink": "_1w3UC",
	"footerCopyright": "_3FMyZ",
	"childRight": "_3PgcV",
	"col3": "_2TNHs",
	"hideMobile": "_3Nop6",
	"showMobile": "_1dgJ_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js!./src/components/Footer/footer.sass
// module id = 899
// module chunks = 0 1 2 3 4 5